/**
 * Lista MPA agrupada por PLANO (GUPM-332) — antes era um card por AÇÃO
 * (`_renderMPAList` do V8, GUPM-193).
 *
 * A carteira segue achatada em ações no domínio; o agrupamento é só a forma de
 * exibi-la. Cada card é um plano (contexto exibido uma vez no cabeçalho) e as
 * ações viram subcards. Sem lógica de negócio aqui — os grupos já chegam
 * agrupados/filtrados do domínio.
 */
import { type AcaoStatus } from '@/domain/planos';
import type { GrupoPlano } from '@/domain/planos/mpa';
import { MpaPlanoCard } from './MpaPlanoCard';

interface Props {
  grupos: GrupoPlano[];
  hoje: Date;
  canEdit: boolean;
  updating: boolean;
  /**
   * Quantos planos da seção de concluídos casam com a barragem/nível do filtro
   * ativo (não o total da seção). Só é usado para o estado VAZIO:
   * ao concluir a última ação em aberto, o plano migra para aquela seção — que
   * nasce fechada — e sem esta pista a tela diria "nenhuma ação corresponde aos
   * filtros" logo depois de o usuário clicar "Concluir", como se o card tivesse
   * sumido. Achado na revisão do PR #212.
   */
  planosConcluidos: number;
  onOpenPlano: (planoId: string) => void;
  onUpdateAcao: (planoId: string, acaoId: string, status: AcaoStatus) => void;
}

export function MpaActionList({
  grupos,
  hoje,
  canEdit,
  updating,
  planosConcluidos,
  onOpenPlano,
  onUpdateAcao,
}: Props) {
  if (grupos.length === 0) {
    return (
      <p className="rounded-xl border border-jf-border bg-jf-surface py-8 text-center text-sm text-jf-muted">
        {planosConcluidos > 0 ? (
          <>
            📋 Nenhuma ação em aberto corresponde aos filtros.
            <br />
            <span className="text-xs">
              {planosConcluidos} plano{planosConcluidos > 1 ? 's' : ''} concluído
              {planosConcluidos > 1 ? 's' : ''} — veja a seção abaixo.
            </span>
          </>
        ) : (
          '📋 Nenhuma ação corresponde aos filtros.'
        )}
      </p>
    );
  }
  return (
    <div className="space-y-2">
      {grupos.map((g) => (
        <MpaPlanoCard
          key={g.planoId}
          grupo={g}
          hoje={hoje}
          canEdit={canEdit}
          updating={updating}
          onOpenPlano={onOpenPlano}
          onUpdateAcao={onUpdateAcao}
        />
      ))}
    </div>
  );
}
